var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 39,
    viewBox: "0 0 49 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1546 38.2957C17.9773 38.1395 3.73395 32.7279 8.12801 24.832C12.5112 16.9556 13.672 7.27605 28.1546 7.02752C42.6371 7.27605 43.798 16.9556 48.1811 24.832C52.5752 32.7279 38.3318 38.1395 28.1546 38.2957Z",
    fill: "#B48EAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8637 33.0166C12.6776 32.8603 -1.57833 27.441 2.81958 19.534C7.20661 11.6465 8.36846 1.95323 22.8637 1.70435C37.359 1.95323 38.5209 11.6465 42.9079 19.534C47.3058 27.441 33.0499 32.8603 22.8637 33.0166Z",
    stroke: "#4C566A",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5174 14.1737V18.6862",
    stroke: "#4C566A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2101 14.1737V18.6862",
    stroke: "#4C566A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluSmall);
export default __webpack_public_path__ + "static/media/flu-small.e1ab691a03c32aff58455c6af5cdbf96.svg";
export { ForwardRef as ReactComponent };